import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check\">\r\n<circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"currentColor\" />\r\n<path d=\"M5.03125 8.42436L6.72822 10.1213L10.9706 5.87891\" fill=\"currentColor\" />\r\n<path d=\"M5.03125 8.42436L6.72822 10.1213L10.9706 5.87891\" stroke=\"white\" stroke-width=\"1.72\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol